
import { Vue, Component } from 'vue-property-decorator';

@Component<StudentsIndex>({})
export default class StudentsIndex extends Vue { }
